module.exports = new __parcel__URL__("space_mobile.514c2b3f.mp4").toString();